import { SET_STAFF_DATA, SET_STAFF_COUNT } from "../types/types";

export const setStaffCount = (value) => {
  return {
    type: SET_STAFF_COUNT,
    payload: { data: value },
  };
};
export const setStaffData = (value) => {
  return {
    type: SET_STAFF_DATA,
    payload: { data: value },
  };
};
export const setCheckPasswordModalOpen = (value) => {
  return {
    type: "SET_CHECK_PASSWORD_MODAL_OPEN",
    payload: { data: value },
  };
};
